export default {
    USER_TYPE: 'userType',
    HAS_VEHICLE_IN_GARAGE: 'hasVehicleInGarage',
};
